var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"wrapper"},[_c('auth-head'),_c('router-view')],1)]),_c('div',{staticClass:"banner"})])}
var staticRenderFns = []

export { render, staticRenderFns }